import React, { Fragment } from "react";
import connectUserPermissions from "@/components/currentUser/CurrentUserPermissions";
import ClientsTable from "./ClientsTable";
import InternalUserInfo from "@/components/internalUserInfo";

const CREATE_CLIENT_ADMIN = "CREATE_CLIENT_ADMIN";

const AdminPage = ({
  actions,
  alertBars,
  clientAdminForm,
  clients,
  clientsNameList,
  currentUser,
  currentUsersAdministeredRoles,
  forms,
  requestClient,
  setClientAdminForm,
  submitCreateClientAdmin,
  userBeingEdited,
}) => {
  const { createClientAdminForm: createClientAdminForm } = forms;
  const {
    forms: { createClientAdminForm: clientAdminFormActions },
    alertBars: {
      createClientAdminAlertBar: clientAdminAlertBarActions,
      adminPageAlertBar: adminPageAlertBarActions,
    },
  } = actions;
  const {
    createClientAdminAlertBar: clientAdminAlertBar,
    adminPageAlertBar: adminPageAlertBar,
  } = alertBars;

  return (
    <Fragment>
      {clientAdminForm ? (
        <InternalUserInfo
          currentUserState={currentUser}
          formType={CREATE_CLIENT_ADMIN}
          form={createClientAdminForm}
          formActions={clientAdminFormActions}
          alertBarActions={clientAdminAlertBarActions}
          alertBar={clientAdminAlertBar}
          submitType={submitCreateClientAdmin}
          closeForm={() => setClientAdminForm(false)}
          roleOptions={currentUsersAdministeredRoles}
          clientOptions={clientsNameList}
          userBeingEdited={userBeingEdited}
        />
      ) : (
        <ClientsTable
          alertBar={adminPageAlertBar}
          alertBarActions={adminPageAlertBarActions}
          clients={clients}
          currentUser={currentUser}
          requestClient={requestClient}
          setClientAdminForm={() => setClientAdminForm(true)}
        />
      )}
    </Fragment>
  );
};

export default connectUserPermissions(AdminPage);
